import React from 'react';
import './CenterContainerHeader.css';
import Typical from 'react-typical';

export default function CenterContainerHeader() {
    return (
        <div className="app-center-container-header">
            <div className="center-container-cover"></div>
            <span className="center-container-header-title-text">
                Discover My Amazing<br></br> Projects!
            </span>
            <div className="header-auto-type-text">
                <div className="auto-type-container">
                    <span className="header-text-tags">
                        &#60;<span className="color-yellow">code</span>&#62;
                    </span>
                    <Typical
                        loop={Infinity}
                        wrapper="span"
                        steps={[
                            'I am a Full Stack Junior Web Developer.', 2000,
                            'I build both front-end and back-end.', 2000,
                            'I have finished 900h junior WEB developer courses in Code Academy.', 2000,
                            'I have finished 160h junior React developer courses in Code Academy.', 2000,
                            'I have finished multiple JS, PHP, React, React Native online courses in Udemy, Coursera and PluralSight.', 2000,
                            'I am working with HTML, CSS, JS, PHP, React, Gatsby, React Native (expo)', 2000,
                            'I am looking for junior position or internship.', 2000,
                            'I have few additional private react projects (companies tasks), contact me to see them', 2000,
                            'At the moment I am improving my knowledge in react, gatsby, typescript full time (8h/day)', 2000,
                            'Also I am learning general programming principles, like KISS, YARN, DRY, etc', 2000
                        ]}
                    />
                    <span className="header-text-tags">
                        &#60;/<span className="color-yellow">code</span>&#62;
                    </span>
                </div>
            </div>
            <button className="header-container-button">
                <a href="https://github.com/Dovtutis" rel="noreferrer noopener" target="_blank" >EXPLORE GITHUB</a>
            </button>
        </div>
    )
}

